var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredentialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.391,
    height: 13.526,
    viewBox: "0 0 17.391 13.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3758",
    transform: "translate(-1850 -886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3758-2",
    transform: "translate(1852.247 888.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8584",
    d: "M1855.9 892.889a1.944 1.944 0 1 0-1.944-1.945 1.946 1.946 0 0 0 1.944 1.945zm0-3.08a1.135 1.135 0 1 1-1.135 1.135 1.136 1.136 0 0 1 1.135-1.134z",
    className: "cls-1",
    transform: "translate(-1852.381 -889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8585",
    d: "M1852.732 896.876a.4.4 0 0 0 .4-.352 2.734 2.734 0 0 1 5.422 0 .4.4 0 0 0 .4.352.405.405 0 0 0 .4-.456 3.544 3.544 0 0 0-7.029 0 .4.4 0 0 0 .4.454z",
    className: "cls-1",
    transform: "translate(-1852.326 -889.147)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8586",
    d: "M1865.459 899.527h-13.527a1.934 1.934 0 0 1-1.932-1.932v-9.662a1.934 1.934 0 0 1 1.932-1.932h13.527a1.934 1.934 0 0 1 1.932 1.932v9.662a1.934 1.934 0 0 1-1.932 1.932zm-13.527-12.56a.967.967 0 0 0-.966.966v9.662a.968.968 0 0 0 .966.966h13.527a.968.968 0 0 0 .966-.966v-9.662a.967.967 0 0 0-.966-.966zm12.561 4.348a.483.483 0 0 0-.482-.483h-2.9a.483.483 0 1 0 0 .966h2.9a.482.482 0 0 0 .483-.482zm0 1.932a.483.483 0 0 0-.482-.483h-2.9a.483.483 0 0 0 0 .966h2.9a.483.483 0 0 0 .483-.482zm0-3.865a.483.483 0 0 0-.482-.483h-2.9a.483.483 0 1 0 0 .966h2.9a.483.483 0 0 0 .483-.482z",
    className: "cls-1",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialIcon);
export default __webpack_public_path__ + "static/media/credential-icon.70b9af85.svg";
export { ForwardRef as ReactComponent };